export default {
  how_to_place_order: {
    header: 'Hvordan afgiver jeg en ordre?',
    body: 'Gennemse blot menuen, læg varer i kurven, og følg trinene i betalingsprocessen. Du modtager en bekræftelse, når ordren er afgivet.',
  },
  schedule_order: {
    header: 'Kan jeg bestille på forhånd?',
    body: 'Ja! Ved betaling skal du vælge „Planlæg“ for at angive et afhentningstidspunkt i fremtiden, der passer dig bedst.',
  },
  customize_order: {
    header: 'Kan jeg tilpasse min ordre?',
    body: 'Absolut. Tryk på en menuvare for at se tilpasningsmuligheder som toppings, tilbehør og præferencer.',
  },
  track_order: {
    header: 'Hvordan følger jeg min ordre?',
    body: 'Når du har afgivet din ordre, kan du se opdateringer i realtid i appen – fra bekræftelse til tilberedning og klar til afhentning.',
  },
  cancel_or_edit_order: {
    header: 'Kan jeg annullere eller ændre min ordre, efter jeg har afgivet den?',
    body: 'Hvis din ordre endnu ikke er påbegyndt, kan du anmode om ændringer ved at ringe direkte til restauranten via appen.',
  },
  payment_methods: {
    header: 'Hvilke betalingsmetoder accepterer I?',
    body: 'Vi accepterer de fleste kredit-/debetkort, Apple Pay og Google Pay afhængigt af din enhed.',
  },
  no_confirmation: {
    header: 'Jeg har ikke modtaget en bekræftelse. Hvad skal jeg gøre?',
    body: 'Tjek din e-mails spammappe, eller gå til fanen Ordrer i appen. Hvis du stadig ikke kan finde den, så kontakt restauranten direkte.',
  },
  pickup_instructions: {
    header: 'Hvor henter jeg min ordre?',
    body: 'Afhentningsinstruktioner vises på bekræftelsesskærmen og i din ordreoversigt. Hold øje med skiltning, eller spørg personalet, når du ankommer.',
  },
  loyalty_points: {
    header: 'Kan jeg optjene loyalitetspoint med mine ordrer?',
    body: 'Ja, kvalificerede køb giver automatisk point. Du kan se din saldo og dine belønninger på appens hovedskærm.',
  },
  apply_promo_code: {
    header: 'Hvordan bruger jeg en rabatkode eller en rabat?',
    body: 'Under betalingen kan du indtaste en rabatkode. Tilgængelige rabatter anvendes også automatisk, hvis du er berettiget.',
  },
  issue_with_order: {
    header: 'Hvad skal jeg gøre, hvis der er et problem med min ordre?',
    body: 'Vi er her for at hjælpe. Kontakt restauranten via appen, eller send en e-mail direkte til support via indstillingen Kontakt support.',
  },
  use_loyalty_and_coupon: {
    header: 'Kan jeg bruge loyalitetspoint og en kupon (f.eks. Køb 1, få 1 gratis) på den samme ordre?',
    body: 'Nej – der kan kun anvendes ét tilbud eller én rabat pr. ordre. Det sikrer rimelig brug af belønninger og kampagner. Vælg den mulighed, der giver dig mest for pengene!',
  },
};
